import { Component, input } from "@angular/core";
import { ROUTES } from "../../../../constants/routes";
import { RouterLink } from "@angular/router";

@Component({
  selector: "app-account-page-wrapper",
  imports: [RouterLink],
  templateUrl: "./account-page-wrapper.html",
  styleUrl: "./account-page-wrapper.scss"
})
export class AccountPageWrapper {
  readonly routes = ROUTES;
  readonly title = input("");
  readonly subtitle = input("");

  readonly highlights = [
    "90,000+ fresh deceased records every week",
    "DOB, date of death, age and addresses on every match",
    "Built for lenders, merchants and fraud teams"
  ];
}
